module.exports = __webpack_public_path__ + "static/media/trash-simple.db418cb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trash-simple.svg
// module id = 65
// module chunks = 0